import { ISize } from 'framework/utils/math-utils';
import { HexGridType } from 'js/bubbleCore/types';
import { isPointyTop } from 'js/bubbleCore/utils/isPointyTop';

export function getHexSize(type: HexGridType): ISize {
  const pointyTop = isPointyTop(type);
  return {
    width: pointyTop ? Math.sqrt(3) : 2,
    height: pointyTop ? 2 : Math.sqrt(2),
  };
}